import { Route } from '@angular/router';

import { authGuard } from '@instaclause-webapp/shared-core';

import { ForgotPasswordComponent } from './layout/forgot-password/forgot-password.component';
import { LoginComponent } from './layout/login/login.component';
import { MainLayoutComponent } from './layout/main/main-layout.component';
import { ResetPasswordComponent } from './layout/reset-password/reset-password.component';


export const appRoutes: Route[] = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [ authGuard ],
    data: {
      breadcrumb: {
        title: 'Expert',
        icon: 'home',
        path: '/home',
      },
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'home',
        loadChildren: () => import('./feature/contract-model/contract-model.routes'),
      },
      {
        path: 'editor',
        loadChildren: () => import('./feature/editor/editor.routes'),
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
];
